function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import { Slide, Fade } from "@chakra-ui/transition";
import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { forwardRef } from "@chakra-ui/system";
import { __DEV__ } from "@chakra-ui/utils";
var TransitionContext = /*#__PURE__*/React.createContext({
  content: {},
  overlay: {}
});
TransitionContext.displayName = "TransitionContext";

var useTransitionContext = function useTransitionContext() {
  return React.useContext(TransitionContext);
};

function DrawerTransition(props) {
  var inProp = props.in,
      children = props.children,
      placement = props.placement;
  return /*#__PURE__*/React.createElement(Slide, {
    timeout: 250,
    in: inProp,
    placement: placement,
    transition: "transform 250ms cubic-bezier(0.16, 1, 0.3, 1)"
  }, function (content) {
    return /*#__PURE__*/React.createElement(Fade, {
      timeout: 250,
      in: inProp,
      transition: "opacity 250ms cubic-bezier(0.16, 1, 0.3, 1)"
    }, function (overlay) {
      return /*#__PURE__*/React.createElement(TransitionContext.Provider, {
        value: {
          content: content,
          overlay: overlay
        }
      }, children);
    });
  });
}

if (__DEV__) {
  DrawerTransition.displayName = "DrawerTransition";
}

export function Drawer(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? "right" : _props$placement,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["isOpen", "onClose", "placement", "children"]);

  return /*#__PURE__*/React.createElement(DrawerTransition, {
    in: isOpen,
    placement: placement
  }, /*#__PURE__*/React.createElement(Modal, _extends({
    isOpen: true,
    onClose: onClose
  }, rest), children));
}
export var DrawerContent = /*#__PURE__*/forwardRef(function DrawerContent(props, ref) {
  var _useTransitionContext = useTransitionContext(),
      styles = _useTransitionContext.content;

  return /*#__PURE__*/React.createElement(ModalContent, _extends({
    ref: ref,
    position: "fixed",
    style: styles,
    marginTop: "0",
    marginBottom: "0",
    borderRadius: "0"
  }, props));
});
export var DrawerOverlay = /*#__PURE__*/forwardRef(function DrawerOverlay(props, ref) {
  var _useTransitionContext2 = useTransitionContext(),
      styles = _useTransitionContext2.overlay;

  return /*#__PURE__*/React.createElement(ModalOverlay, _extends({
    style: styles,
    ref: ref
  }, props));
});
import { ModalBody, ModalHeader, ModalFooter, ModalCloseButton } from "@chakra-ui/modal";
export var DrawerBody = ModalBody;
export var DrawerHeader = ModalHeader;
export var DrawerFooter = ModalFooter;
export var DrawerCloseButton = ModalCloseButton;